export const formatDistance = (meters: string | number) => {
  if (Number(meters) >= 1000) {
    return `${(Number(meters) / 1000).toFixed(1)}km`;
  }
  return `${meters}m`;
};
